import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { API_BASE_URL, API_KEY } from "../../../config/config";
import { AuthContext } from "../../../context/authContext";
import qs from "qs";
import UserAvatar from "../../common/UserAvatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faExpandArrowsAlt, faReply } from "@fortawesome/free-solid-svg-icons";
import {t} from "i18next";

const CommentFormTemplate = ({ video, addNewComment }) => {
	const { visitor } = useContext(AuthContext);

	const [templates, setTemplates] = useState([]);
	const [selectedTemplateId, setSelectedTemplateId] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		const fetchTemplates = async () => {
			try {
				let config = {
					method: 'get',
					maxBodyLength: Infinity,
					url: `${API_BASE_URL}/threads/${video.Post.thread_id}/reply-templates`,
					headers: {
						'XF-Api-Key': API_KEY,
						'XF-Api-User': visitor.user_id,
					},
					withCredentials: true
				};

				const response = await axios.request(config);
				setTemplates(response.data.templates || []);
			} catch (error) {
				console.error('Failed to fetch comment templates:', error);
			}
		};

		fetchTemplates();
	}, [video.Post.thread_id, visitor.user_id]);

	const handleTemplateChange = (event) => {
		setSelectedTemplateId(event.target.value);
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		setIsSubmitting(true);
		setError('');

		const selectedTemplate = templates.find(template => template.template_id === parseInt(selectedTemplateId));

		if (!selectedTemplate) {
			setError(t('please_select_valid_reply_template'));
			setIsSubmitting(false);
			return;
		}

		try {
			let data = qs.stringify({
				'template_id': selectedTemplate.template_id,
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${API_BASE_URL}/threads/${video.Post.thread_id}/template-reply`,
				headers: {
					'XF-Api-Key': API_KEY,
					'XF-Api-User': visitor.user_id,
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: data,
				withCredentials: true
			};

			const response = await axios.request(config);
			let comment = response.data.post;

			addNewComment(comment);

			setSelectedTemplateId('');
		} catch (error) {
			console.error('Failed to post comment:', error);
			setError('Failed to post comment. Please try again.');
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div className="flex-1 p-1 min-w-0">
			<div className="flex flex-col h-full">
				<form onSubmit={handleSubmit} className="reply-form max-w-sm">
					<div className="form-group">
						<label htmlFor="commentTemplate" className="block mb-2 text-sm font-medium text-white">
							Chọn một mẫu bình luận:
						</label>

						<select
							id="commentTemplate"
							value={selectedTemplateId}
							onChange={handleTemplateChange}
							className="form-control block w-full p-2 mb-6 text-sm text-white border border-borderColor rounded-lg bg-primary focus:ring-primary focus:ring-opacity-85 focus:border-primary focus:border-opacity-85"
							disabled={isSubmitting}
						>
							<option value="">Select a template...</option>
							{templates.map(template => (
								<option key={template.template_id} value={template.template_id}>
									{template.message}
								</option>
							))}
						</select>
					</div>

					{error && <p className="mt-2 error text-red-500 font-bold text-sm">{error}</p>}

					<div className="mt-2 flex flex-wrap items-center gap-2">
						<button type="submit" className="flex-1 button bg-secondary" disabled={isSubmitting}>
							<FontAwesomeIcon icon={faReply} className="mr-2"/>
							{isSubmitting ? 'Loading...' : 'Bình luận'}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default CommentFormTemplate;
